.pagination {
  width: 100%;
  display: flex;
  overflow: auto;
  justify-content: center;
  margin-top: 8px;
  // margin-bottom: 10px;
  &__wrapper {
    display: flex;
    align-items: center;
    overflow: hidden;
  }
}
.pagination-animation {
  transition: transform 200ms;
  display: flex;
  .dot {
    border-radius: 50%;
    transition: all 200ms;
  }
}
